import { SettingUrls } from 'constants/SettingsUrls';
import { SettingKey } from 'data/ppoints/constants';
import { useEmbeddedStatusSwr } from 'hooks/embedded-status/useEmbeddedStatusSwr';
import useSettings from 'hooks/useSettings';
import { IntegrationModeSetting } from 'models/ppoints/settings/SettingsToEcom';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { IntegrationStatusList } from './integration-status-list/IntegrationStatusList';

export const EmbeddedStatus = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { isLoading: isLoadingExtensions, error, mutate, isValidating } = useEmbeddedStatusSwr();
    const setting = useSettings<IntegrationModeSetting>(SettingKey.integration_mode);

    const integrationMode = useMemo<IntegrationModeSetting>(() => setting.settings, [setting.settings]);

    const isLoading = useMemo(() => isLoadingExtensions || isValidating, [isLoadingExtensions, isValidating]);

    const hasIntegrationMode = useMemo(() => {
        return !!integrationMode;
    }, [integrationMode]);

    return (
        <s-section>
            <div className="flex flex-col gap-3">
                <div className="flex gap-2 justify-between items-center">
                    <div className="flex flex-col gap-1.5">
                        <s-heading>{t('DASHBOARD.APP_EXTENSIONS.TITLE')}</s-heading>
                        <s-text color="subdued">{t('DASHBOARD.APP_EXTENSIONS.DESCRIPTION')}</s-text>
                    </div>
                    <div>
                        {hasIntegrationMode && (
                            <s-button variant="tertiary" onClick={() => mutate()} loading={isLoading}>
                                {t('DASHBOARD.APP_EXTENSIONS.REFRESH')}
                            </s-button>
                        )}
                        {!hasIntegrationMode && (
                            <s-button variant="tertiary" onClick={() => navigate(SettingUrls.integrationMode)}>
                                {t('DASHBOARD.APP_EXTENSIONS.SET_UP_INTEGRATION_MODE')}
                            </s-button>
                        )}
                    </div>
                </div>
                {hasIntegrationMode ? (
                    <div className="py-2 px-4 rounded-lg border border-border">
                        <IntegrationStatusList />
                    </div>
                ) : (
                    <s-banner tone="warning">
                        <s-text color="subdued">{t('DASHBOARD.APP_EXTENSIONS.NO_INTEGRATION_MODE_DESCRIPTION')}</s-text>
                    </s-banner>
                )}
            </div>
        </s-section>
    );
};
